import DeviceManager from '../utils/device-manager';

const Header = {
    $header: null,
    isSticky: false,
    mobileInitialized: false,
    $menuTogglers: null,
    $buttonsContainer: null,
    $buttonsToHighliteOnMobile: null,
    $buttonsHighlitedOnMobile: null,
    $itemChildrenTogglers: null,
    $submenusBackButtons: null,
    $menuItemsHasChildren: null,
    offsetTop: 0,

    init() {
        const that = this;

        this.$header = document.querySelector('#header');
        this.$menuTogglers = this.$header.querySelectorAll('.js-header-menu-toggler');
        this.$buttonsContainer = this.$header.querySelector('.js-header-buttons-container');
        this.$buttonsToHighliteOnMobile = this.$header.querySelectorAll('.js-highlight-mobile');
        this.$itemChildrenTogglers = this.$header.querySelectorAll('.js-menu-item-has-children > a');
        this.$submenusBackButtons = this.$header.querySelectorAll('.sub-menu .js-menu-item-title');

        this.$headerPrimary = this.$header.querySelector('.header-primary-menu');
        this.$headerSecondary = this.$header.querySelector('.header-secondary-menu');
        /* console.log(this.$headerSecondary);
        console.log(this.$headerPrimary); */
        if (this.$headerPrimary) {
            this.$headerPrimary.style.zIndex = 10;

            /* this.$headerPrimary.addEventListener("click", _event => {
                console.log('primary');
                this.$headerPrimary.style.zIndex = 10;
                this.$headerSecondary.style.zIndex = 0;
            });

            this.$headerSecondary.addEventListener("click", _event => {
                console.log('secondary');
                this.$headerPrimary.style.zIndex = 0;
                this.$headerSecondary.style.zIndex = 10;
            }); */

            this.$headerPrimary.querySelectorAll('a').forEach( primaryLink => {
                primaryLink.addEventListener("click", _event => {
                    this.$headerPrimary.style.zIndex = 10;
                    this.$headerSecondary.style.zIndex = 0;
                })
            });
        }
        if (this.$headerSecondary) {
            this.$headerSecondary.querySelectorAll('a').forEach( secondaryLink => {
                secondaryLink.addEventListener("click", _event => {
                    this.$headerPrimary.style.zIndex = 0;
                    this.$headerSecondary.style.zIndex = 10;
                })
            });
        }



        const links = document.querySelectorAll('a[href^="#"]:not(.js-faq-list-nav-item)');

        links.forEach(link => {
            link.addEventListener("click", _event => {
                // console.log (_event);
                // this.smoothScrollEvent = _event;
                this.smoothScroll (_event.target.hash, _event); 
            });
        });

        this.$itemChildrenTogglers.forEach($childrenToggler => {
            $childrenToggler.addEventListener('click', e => {
                e.preventDefault();
                e.stopPropagation();
            });
        });

        this.addOnScrollEvent();

        // remove id empty
        document.querySelectorAll('.strate').forEach( el => {
            if (el.getAttribute ("id").trim() == '') {
                el.removeAttribute('id');
            }
        })

        DeviceManager.addCallback(attr => {
            if (!that.mobileInitialized && !DeviceManager.isGreaterThan(attr.current, 'md')) {
                that.enableMobile();
            } else if (that.mobileInitialized && DeviceManager.isGreaterThan(attr.current, 'md')) {
                that.disableMobile();
            }

            if (DeviceManager.isGreaterThan(attr.current, 'sm')) {
                this.offsetTop = 155;
            } else {
                this.offsetTop = 95;
            }
        });
    },

    addOnScrollEvent() {
        const that = this;
        const excludePages = ['page-template-landing-page'];

        let executeSticky = true;

        // Add sticky class when pageYOffset > 0
        excludePages.forEach(function (pageClass) {
            console.log(pageClass);
            if (document.querySelector('body').classList.contains(pageClass)) {
                executeSticky = false;
            }
        })

        if (executeSticky) {
            const addStickyClass = () => {
                if (!that.isSticky && window.pageYOffset > 0) {
                    that.isSticky = true;
                    that.$header.classList.add('is-sticky');
                } else if (that.isSticky && window.pageYOffset === 0) {
                    that.isSticky = false;
                    that.$header.classList.remove('is-sticky');
                }
            }

            addStickyClass();
            window.addEventListener('scroll', addStickyClass);
        }
    },

    callbackToggleMobileMenu(e) {
        const $header = document.querySelector('#header');
        $header.classList.toggle('is-open');
        document.body.classList.toggle('scroll-blocked');

        const $itemWithSubmenuOpened = $header.querySelector('.js-menu-item-has-children.open');
        if ($itemWithSubmenuOpened) {
            $itemWithSubmenuOpened.querySelector('.js-menu-item-title').click();
        }
    },

    callbackOpenMobileSubmenu(e) {
        e.preventDefault();
        e.stopPropagation();

        const $link = e.target;
        const $item = $link.parentElement;

        $item.classList.add('open');
    },

    callbackCloseMobileSubmenu(e) {
        e.preventDefault();
        e.stopPropagation();

        const $button = e.target;
        const $submenu = $button.parentElement;
        const $item = $submenu.parentElement;

        $item.classList.add('anim-close');
        $item.classList.remove('open');

        const ontransitionend = e => {
            const $submenu = e.target;
            const $item = $submenu.parentElement;

            $item.classList.remove('anim-close');

            $submenu.removeEventListener('transitionend', ontransitionend);
        };

        $submenu.addEventListener('transitionend', ontransitionend);
    },

    enableMobile() {
        this.mobileInitialized = true;
        
        // Clone highlighted buttons
        if (!this.$buttonsHighlitedOnMobile) {
            this.$buttonsHighlitedOnMobile = [];

            this.$buttonsToHighliteOnMobile.forEach($button => {
                const $clonedButton = $button.cloneNode();
                $clonedButton.innerHTML = $button.querySelector('svg').outerHTML;
                $clonedButton.classList = 'header-button';

                if ($button.classList.contains('btn-secondary')) {
                    $clonedButton.classList.add('header-button--secondary');
                } else if ($button.classList.contains('btn-primary')) {
                    $clonedButton.classList.add('header-button--primary');
                }

                this.$buttonsContainer.prepend($clonedButton);
                this.$buttonsHighlitedOnMobile.push($clonedButton);
            });
        }

        this.$menuTogglers.forEach($toggler => {
            $toggler.addEventListener('click', this.callbackToggleMobileMenu);
        });

        this.$itemChildrenTogglers.forEach($item => {
            $item.addEventListener('click', this.callbackOpenMobileSubmenu);
        });

        this.$submenusBackButtons.forEach($button => {
            $button.addEventListener('click', this.callbackCloseMobileSubmenu);
        });
    },

    disableMobile() {
        this.mobileInitialized = false;

        this.$menuTogglers.forEach($toggler => {
            $toggler.removeEventListener('click', this.callbackToggleMobileMenu);
        });

        this.$itemChildrenTogglers.forEach($item => {
            $item.removeEventListener('click', this.callbackOpenMobileSubmenu);
        });

        this.$submenusBackButtons.forEach($button => {
            $button.addEventListener('click', this.callbackCloseMobileSubmenu);
        });
    },

    smoothScroll (_target, _event = false) {
        /* let _event = this.smoothScrollEvent;
        let _target = _event.target.hash; */

        console.log("TEST SCROLL");
        if (_target === '') {
            return;
        }
        
        if (_event) {
            _event.preventDefault ();
        }
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const $elem = document.querySelector(_target);
        const rect = $elem.getBoundingClientRect();

        if ( document.body.classList.contains('ie') || document.body.classList.contains('edge')) {
            scroll (0, scrollTop + rect.top - 100);
        } else {
            scroll({
                top: ( scrollTop + rect.top - this.offsetTop),
                behavior: "smooth"
            });
        }
    }
};

export default Header;
